/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2020 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

/* eslint-disable no-param-reassign */
import { types } from 'mobx-state-tree';
import PublishInfo from './PublishInfo';

export default types
  .model('BulkProject', {
    id: types.maybeNull(types.string),
    name: types.maybeNull(types.string),
    authorName: types.maybeNull(types.string),
    entityUrn: types.maybeNull(types.string),
    status: types.maybeNull(types.string),
    publishStatus: types.maybeNull(types.string),
    productId: types.maybeNull(types.string),
    lineOfBusiness: types.maybeNull(types.string),
    dateCreated: types.maybeNull(types.string),
    publishDestination: types.maybeNull(types.string),
    publishInfo: types.maybeNull(PublishInfo),
    previousDistributableUrn: types.maybeNull(types.string),
    isEpubProject: false,
    isTccProject: false,
    isEbookProject: false,
    isCypressPlusEnabled: false,
    isH5PContentEnabled: false,
    EnableTeacherAssistant: false,
    isSbrEnabled: false,
    isPearsonPlusEnabled: false,
    category: types.maybeNull(types.string),
    sharingContextRole: types.maybeNull(types.string)
  })
  .actions(self => ({
    update({
      id,
      name,
      authorName,
      entityUrn,
      status,
      publishStatus,
      productId,
      lineOfBusiness,
      dateCreated,
      publishDestination,
      publishInfo,
      previousDistributableUrn,
      isEpubProject,
      isTccProject,
      isEbookProject,
      isCypressPlusEnabled,
      isH5PContentEnabled,
      EnableTeacherAssistant,
      isSbrEnabled,
      isPearsonPlusEnabled,
      category,
      sharingContextRole
    }) {
      self.id = id;
      self.name = name;
      self.authorName = authorName || null;
      self.entityUrn = entityUrn;
      self.status = status;
      self.publishStatus = publishStatus;
      self.productId = productId;
      self.lineOfBusiness = lineOfBusiness;
      self.dateCreated = dateCreated;
      self.publishDestination = publishDestination;
      self.publishInfo = publishInfo;
      self.previousDistributableUrn = previousDistributableUrn;
      self.isEpubProject = Boolean(isEpubProject);
      self.isTccProject = Boolean(isTccProject);
      self.isEbookProject = Boolean(isEbookProject);
      self.isCypressPlusEnabled = Boolean(isCypressPlusEnabled);
      self.isH5PContentEnabled = Boolean(isH5PContentEnabled);
      self.EnableTeacherAssistant = Boolean(EnableTeacherAssistant);
      self.isSbrEnabled = Boolean(isSbrEnabled);
      self.isPearsonPlusEnabled = Boolean(isPearsonPlusEnabled);
      self.category = category || null;
      self.sharingContextRole = sharingContextRole || null;
    },
    updateProjectStatus(value) {
      self.status = value;
    },
    updatePublishInfo(statusObj) {
      self.publishInfo = statusObj ? statusObj.publishInfo : null;
    }
  }));
